export const BaaFeatureLimits = () => (
  <ul className="list-disc space-y-1 pl-4 text-muted-foreground">
    <li>
      Web pages: Some public pages cannot be read, even if they open in your
      browser.
    </li>
    <li>Web search: Uses a smaller set of search providers.</li>
    <li>Chat models: Some models are replaced or unavailable.</li>
    <li>Spoken replies: Some voices are replaced.</li>
    <li>
      People and company research: Dedicated tools for public profiles, company
      records and financial filings are unavailable.
    </li>
    <li>Email importance: Automatic importance scoring is unavailable.</li>
  </ul>
);
